module.exports = "#chip{width:100%}#button-container{display:flex;justify-content:center;align-items:center}\n"